import { useState } from 'react';
import { getUsersByLocation } from '../utils/apiCalls';
import UserInfo from './UserInfo';

export default function LocationUsers({ locationId, token, user }) {
    const [locationUsers, setLocationUsers] = useState({});
    const [openUserList, setOpenUserList] = useState({});
    const [showDeactivatedUsers, setShowDeactivatedUsers] = useState(false);
    const [showUserModal, setShowUserModal] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);

    const loadUsers = async(locationId) => {
        try {
            if (openUserList[locationId]) {
                setOpenUserList(prev => ({ ...prev, [locationId]: false }));
                return;
            }

            if (!locationUsers[locationId]) {
                const users = await getUsersByLocation(locationId, token);

                setLocationUsers(prev => ({ ...prev, [locationId]: users }));
            }
            
            setOpenUserList(prev => ({ ...prev, [locationId]: true }));
        } catch (error) {
            console.error('Error loading users for location', error);
        }
    };

    const refreshUsers = async(locId) => {
        try {
            const users = await getUsersByLocation(locId, token);
            setLocationUsers(prev => ({ ...prev, [locId]: users}));
        } catch (error) {
            console.error('Error refreshing users', error);
        }
    };

    const openUserModal = (user) => {
        setShowUserModal(true);
        setCurrentUser(user);
    }

    const usersForLocation = locationUsers[locationId] || [];
    const hasDeactivatedUsers = usersForLocation.some(users => !users.is_active);

    const visibleUsers = showDeactivatedUsers ? usersForLocation : usersForLocation.filter(users => users.is_active);

    return(
        <div>
            <div>
                <button onClick={() => loadUsers(locationId)} className='text-sm px-2 py-1 rounded shadow-md text-white voco-gradient-hover'>
                    {openUserList[locationId] ? 'hide' : 'view users'}
                </button>
            </div>
            {openUserList[locationId] && (
                <div className='ml-4'>
                    <h5 className='font-medium'>Users:</h5>
                        {hasDeactivatedUsers && (
                            <div className='flex items-center gap-2 mb-2'>
                                <input type='checkbox' id={`show-inactive-${locationId}`} checked={showDeactivatedUsers} onChange={(event) => setShowDeactivatedUsers(event.target.checked)} className='accent-docpgrPurple60 w-3 h-3 rounded border-gray-300' />
                                <label htmlFor={`show-inactive-${locationId}`} className='text-sm text-gray-700 cursor-pointer'>
                                    show deactivated users
                                </label>
                            </div>
                        )}

                        {visibleUsers.length > 0 ? (
                            locationUsers[locationId] ? (
                                locationUsers[locationId].length > 0 ? (
                                    <ul className="list-disc list-inside">
                                        {visibleUsers.map((user) => (
                                            <li key={user.user_id} onClick={() => openUserModal(user)} className={`px-4 py-2 ${user.is_active ? '' : 'bg-gray-50'} hover:bg-docpgrPurple10 rounded-md`}>
                                                <span className='text-gray-800'>{user.full_name} </span><span className="text-gray-600 text-sm italic">{user.is_active ? '' : '- deactivated'} </span>  
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p className="text-gray-500">no users found</p>
                                    )
                            ) : (
                                <p className="text-gray-500">loading...</p>
                            )
                        ) : <p className="text-gray-500">no users found</p>}
                </div>
                )}

            {showUserModal && (
                <UserInfo user={currentUser} setCloseModal={setShowUserModal} refreshUsers={refreshUsers} locationId={locationId} />
            )}
        </div>
    )
}